__turbopack_context__.v({
  "bottom": "website-builder-footer-module__8CuwlW__bottom",
  "brand": "website-builder-footer-module__8CuwlW__brand",
  "contact": "website-builder-footer-module__8CuwlW__contact",
  "content": "website-builder-footer-module__8CuwlW__content",
  "copy": "website-builder-footer-module__8CuwlW__copy",
  "footer": "website-builder-footer-module__8CuwlW__footer",
  "heading": "website-builder-footer-module__8CuwlW__heading",
  "identity": "website-builder-footer-module__8CuwlW__identity",
  "inner": "website-builder-footer-module__8CuwlW__inner",
  "legal": "website-builder-footer-module__8CuwlW__legal",
  "links": "website-builder-footer-module__8CuwlW__links",
  "logo": "website-builder-footer-module__8CuwlW__logo",
  "navigation": "website-builder-footer-module__8CuwlW__navigation",
});
